// extracted by mini-css-extract-plugin
export default {"container":"VideoWithText_container__yyIPr","video":"VideoWithText_video__wsh1m","textOverlay":"VideoWithText_textOverlay__oFo+s"};